
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.75 23.25A3.754 3.754 0 010 19.5V9a3.754 3.754 0 013.75-3.75h6.973L7.012 2.069a.747.747 0 01-.081-1.057.746.746 0 011.057-.081l4.723 4.048L16.72.97a.744.744 0 011.06 0c.142.141.22.33.22.53s-.078.389-.22.53l-3.22 3.22h5.689A3.754 3.754 0 0124 9v10.5a3.754 3.754 0 01-3.75 3.75H3.75zm0-16.5A2.252 2.252 0 001.5 9v10.5a2.252 2.252 0 002.25 2.25h16.5a2.252 2.252 0 002.25-2.25V9a2.252 2.252 0 00-2.25-2.25H3.75z"}}),_c('path',{attrs:{"d":"M9.605 20.25c-1.605 0-3.217-.156-4.793-.465A2.255 2.255 0 013 17.577v-6.655a2.254 2.254 0 011.809-2.207 25.254 25.254 0 014.842-.465h.227c1.616 0 3.234.156 4.81.464a2.258 2.258 0 011.812 2.209v6.655c0 1.069-.76 1.998-1.809 2.208a25.026 25.026 0 01-4.799.465l-.287-.001zm.275-1.5a23.64 23.64 0 004.519-.436c.347-.07.6-.379.6-.736v-6.656a.753.753 0 00-.603-.737 23.483 23.483 0 00-4.492-.435h-.292c-1.512 0-3.03.147-4.512.436a.75.75 0 00-.6.735v6.656c0 .357.253.667.603.737 1.477.289 3.01.436 4.556.436h.221z"}}),_c('circle',{attrs:{"cx":"19.5","cy":"11.625","r":"1.125"}}),_c('circle',{attrs:{"cx":"19.5","cy":"15.75","r":"1.125"}})])
          )
        }
      }
    